export class ContactPhoneNumberModel {
  phoneNumber: string;
  phoneType: string;
}
